import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import Cookies from "js-cookie";
const SchemeForm = () => {
  const [schemeName, setSchemeName] = useState("");
  const [schemeEndDate, setSchemeEndDate] = useState("");
  const [errors, setErrors] = useState({});
  const [schemes, setSchemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [schemeToDelete, setSchemeToDelete] = useState(null);
  const token = Cookies.get('admin');
  console.log(token);
 useEffect(() => {
  const fetchSchemes = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Scheme/all`, {
        headers: {  
          "Content-Type": "application/json",
          "Authorization": token ? `Bearer ${token}` : "",
        },  
      });
      
      console.log("Raw response data:", response.data); // Log the raw data
      
      const sortedSchemes = response.data.sort((a, b) => new Date(b.schemeEndDate) - new Date(a.schemeEndDate));
      setSchemes(sortedSchemes);
    } catch (error) {
      console.error("Error fetching schemes:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchSchemes();
}, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!schemeName) newErrors.schemeName = "Scheme Name is required";
    if (!schemeEndDate) newErrors.schemeEndDate = "Scheme Date is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/Scheme/create`,
        {
          schemeName,
          schemeEndDate,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
          },
        }
      );

      console.log("Scheme created:", response.data);
      setSchemeName("");
      setSchemeEndDate("");

      const updatedResponse = await axios.get(`${API_BASE_URL}/Scheme/all`,
        {
          headers: {  "Content-Type": "application/json" ,
        "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
       },  
        }
      );
      const sortedSchemes = updatedResponse.data.sort((a, b) => new Date(b.schemeEndDate) - new Date(a.schemeEndDate));
      setSchemes(sortedSchemes);
    } catch (error) {
      console.error("Error creating scheme:", error);
    }
  };

  const handleToggleVisibility = async (schemeId, currentStatus) => {
    try {
      await axios.patch(`${API_BASE_URL}/Scheme/hide/${schemeId}`, {
        LiveScheme: !currentStatus,
      }, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
        },
      });

      const updatedResponse = await axios.get(`${API_BASE_URL}/Scheme/all`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
        },
      });
      const sortedSchemes = updatedResponse.data.sort((a, b) => new Date(b.schemeEndDate) - new Date(a.schemeEndDate));
      setSchemes(sortedSchemes);
    } catch (error) {
      console.error("Error updating scheme visibility:", error);
    }
  };

  const handleDelete = async (schemeId) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this scheme?");
    if (isConfirmed) {
      try {
        await axios.delete(`${API_BASE_URL}/Scheme/delete/${schemeId}`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
          },
        });

        const updatedResponse = await axios.get(`${API_BASE_URL}/Scheme/all`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
          },
        });
        const sortedSchemes = updatedResponse.data.sort((a, b) => new Date(b.schemeEndDate) - new Date(a.schemeEndDate));
        setSchemes(sortedSchemes);
      } catch (error) {
        console.error("Error deleting scheme:", error);
      }
    }
  };

  const handleSelectChange = async (schemeId, e) => {
    const updatedStatus = e.target.value === "active"; // Determine if the value is active

    try {
      // Call the backend to update the status``````````
      await axios.patch(`${API_BASE_URL}/Scheme/hide/${schemeId}`, {
        LiveScheme: updatedStatus,
      }, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
        },
      });

      // After the update, fetch the updated list of schemes
      const updatedResponse = await axios.get(`${API_BASE_URL}/Scheme/all`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
        },
      });
      const sortedSchemes = updatedResponse.data.sort((a, b) => new Date(b.schemeEndDate) - new Date(a.schemeEndDate));
      setSchemes(sortedSchemes);
    } catch (error) {
      console.error("Error updating scheme visibility:", error);
    }
  };


  

  return (
    <div className="flex flex-col items-center justify-start min-h-screen p-4 sm:p-6">
    {/* Create New Scheme Box */}
    <div className="w-full p-8 bg-white rounded-lg shadow-lg mb-6">
      <h2 className="text-3xl font-bold mb-6 text-left text-gray-900">Create New Scheme</h2>
      <div className="-mx-8">
        <hr className="border-gray-300 mb-8" />
      </div>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="flex flex-col sm:flex-row space-x-4 sm:space-x-4">
          <div className="w-full">
            <label htmlFor="schemeName" className="block text-sm font-medium text-gray-700 mb-1">Scheme Name</label>
            <input
              type="text"
              id="schemeName"
              className="mt-1 block w-full py-2 px-4 border border-gray-300 rounded-lg shadow-sm focus:ring-gray-500 focus:border-gray-500 focus:outline-none sm:text-sm"
              value={schemeName}
              onChange={(e) => setSchemeName(e.target.value)}
            />
            {errors.schemeName && (
              <p className="mt-1 text-red-600 text-sm">{errors.schemeName}</p>
            )}
          </div>
  
          <div className="w-full">
            <label htmlFor="schemeEndDate" className="block text-sm font-medium text-gray-700 mb-1">Scheme End Date</label>
            <input
              type="date"
              id="schemeEndDate"
              className="mt-1 block w-full py-2 px-4 border border-gray-300 rounded-lg shadow-sm focus:ring-gray-500 focus:border-gray-500 focus:outline-none sm:text-sm"
              value={schemeEndDate}
              onChange={(e) => setSchemeEndDate(e.target.value)}
            />
            {errors.schemeEndDate && (
              <p className="mt-1 text-red-600 text-sm">{errors.schemeEndDate}</p>
            )}
          </div>
  
          {/* Submit Button */}
          <div className="flex pt-4 items-stretch ">
            <button
              type="submit"
              className="w-full h-12 px-6 text-base bg-gradient-to-r from-[#1C50A3] to-[#2B68C8] text-white rounded-lg font-semibold hover:bg-gradient-to-r hover:from-[#2B68C8] hover:to-[#1C50A3] transition duration-300 whitespace-nowrap"
            >
              Submit Scheme
            </button>
          </div>
        </div>
      </form>
    </div>
  
    {/* Live Schemes Box */}
    <div className="w-full p-1">
      {loading ? (
        <p className="text-center text-gray-500">Loading...</p>
      ) : (
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {schemes.length > 0 ? (
            schemes.map((scheme) => (
              <li
                key={scheme._id}
                className="p-6 shadow-md bg-white rounded-xl border-b-4 border-[#1C50A3] cursor-pointer hover:shadow-xl transition duration-300"
              >
                <div className="flex flex-col sm:flex-row space-x-0 sm:space-x-2 mb-4 justify-between">
                  {/* Dropdown for Active/Inactive with correct status colors */}
                  <div className="relative">
                    <select
                      onChange={(e) => handleSelectChange(scheme._id, e)}
                      className={`py-2 pl-4 pr-8 rounded-full font-semibold transition duration-300 ${scheme.LiveScheme ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'} w-24 outline-none border-none appearance-none cursor-pointer`}
                      value={scheme.LiveScheme ? "active" : "inactive"}
                    >
                      <option value="active" className="bg-green-100 text-green-600">Active</option>
                      <option value="inactive" className="bg-red-100 text-red-600">Inactive</option>
                    </select>
  
                    {/* Custom Dropdown Arrow inside the select box */}
                    <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 text-gray-600">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
  
                  {/* Delete button with icon on the right */}
                  <div className="flex justify-end">
                    <button
                      onClick={() => handleDelete(scheme._id)}
                      className="px-2 h-8 w-8 bg-[#EB1313] text-white rounded-lg font-semibold shadow-[0_6px_10px_0_rgba(235,19,19,0.5)] hover:shadow-[0_10px_15px_0_rgba(235,19,19,0.7)] transition duration-300 mt-2 sm:mt-0 flex items-center cursor-pointer"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>
  
                <div className="flex-1 space-y-2">
                  <p className="text-gray-800 font-semibold"><strong>Scheme Name:</strong> {scheme.schemeName}</p>
                  <p className="text-gray-500"><strong>Scheme End Date:</strong> {new Date(scheme.schemeEndDate).toLocaleDateString()}</p>
                  <p className="text-gray-500"><strong>Scheme ID:</strong> {scheme.schemeId}</p>
                </div>
              </li>
            ))
          ) : (
            <p className="text-center text-gray-500">No schemes available.</p>
          )}
        </ul>
      )}
    </div>
  </div>
  
  );
};

export default SchemeForm;
